var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBottom = function SvgBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 462,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M462 0H0l24.308 10.955 21.03 1.934L74.16 7.466l28.94 3.489 17.376-3.489 15.917 5.423 34.009-1.934 34.007-2.536 28.783 6.374 24.876-4.666 9.117 4.666 31.518-8.201 29.78 1.827h27.916l53.956 8.424 32.117-5.888L462 0Z",
    fill: "#fff"
  })));
};

export default SvgBottom;